import { factory as flaxiosFactory } from 'Utils/flaxios';
import getOrigin from 'Utils/get-origin';

export default flaxiosFactory({
  baseURL: `${getOrigin()}/api/v2/reporting`,
  headers: { 'Content-Type': 'application/json' },
});
